import{PublicKey as e}from"@solana/web3.js";import"../node_modules/buffer/index.mjs";import{__exports as o}from"../_virtual/index.mjs";const r=new e("nftD3vbNkNqfj2Sd3HZwbpw4BxxKWr4AjGb9X38JeZk"),m=o.Buffer.from("tokenized_name");export{m as MINT_PREFIX,r as NAME_TOKENIZER_ID};
//# sourceMappingURL=const.mjs.map
